// ENUMS

export enum EnergyType {
  BIO = 'Bio Energy',
  SOLAR = 'Solar',
  WATER = 'Water',
  WIND = 'Wind'
}

export enum ProducerImageTypes {
  EXTRA = 'extra',
  HEADER = 'header',
  LOGO = 'logo',
  PROFILE = 'profile'
}

export enum ProducerStatus {
  AVAILABLE = 'Available',
  RESERVED = 'Reserved',
  SOLD_OUT = 'Sold Out'
}

// TYPES

export type Locales<T> = {
  nl: T
  fr: T
}

export type ProducerStore = {
  error: boolean
  loading: boolean
  latestProducerID: number
  uploadingImage: ProducerImageTypes | null
  producers: Producer[]
  producer?: Producer
  contracts: Contract[]
}

export type Producer = {
  id: string
  description: Locales<string>
  enabled: boolean
  facts?: Locales<string[]>
  images: ImageObject
  longDescription?: Locales<string>
  name: Locales<string>
  slug: string
  coordinates: Coordinates
  currentCapacity: number
  energyType: EnergyType
  energyUsed: number
  isSoldOut: boolean
  location: string
  maxCapacity: number
  minOccupation: number
  energyRegion: string
  isFeatured: Locales<boolean>
  isPopular: Locales<boolean>
  order: number
  parentSlug: string
  salesforceId: string
  state: ProducerStatus
}

export type Coordinates = {
  lat: number
  long: number
}

export type ImageObject = {
  extra?: Image[]
  header?: Image
  logo?: Image
  profile?: Image
}

export type Image = {
  url?: string
  name?: string
}

export type Contract = {
  contractID: string
  producerID: string
  fromDate: string
  toDate: string
  newProducerID: string
  newFromDate: string
  newToDate: string
  contractStartDate: string
  effectiveEndDate: string
  customerNbr: string
  contractStatusCode: string
  energyType: string
  contractType: string
  billingContractNbr: string
  productCode: string
  disabled?: boolean
}

export type UpdateContractProducerData = {
  contracts: Contract[]
  newProducer: {
    id: string
    fromDate: string
    toDate?: string
  }
}

export type HistoryContract = {
  _id: string
  contractId: string
  createdAt: string
  updatedAt: string
}
